import React from 'react'
import disconnectedIcon from '../../assets/icons/disconnected-status.svg'
import Text from "../i18n/Text";

export default function CaseUnknown() {
    return <div className="d-flex flex-column justify-content-center align-items-center">
        <h1 data-test-id="2ed6b9dc-1496"><Text k='identification.not.possible'/></h1>
        <img src={disconnectedIcon} alt="verified" className="m-4" data-test-id="0df48425-8be9"/>
        <p className="fs-5" data-test-id="2654a2e1-f332">
            <Text k="caseId.not.found"/>
        </p>
    </div>
}